<template>
    <transition name="modal">
        <div id="addUserToTalkgroup" class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-if="authUsers.length === 0" v-t="'message.title_bell_add_auth'"></div>
                    <div v-else v-t="'message.title_bell_edit_auth'"></div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <UserSelection
                        :appData="appData"
                        :title="selectedTitle"
                        :selectedUsers="authUsers"
                        :selectionType="selectionType"
                        @changeSelectedUser="handleChangeSelectedUser()"
                        ref="UserSelection">
                    </UserSelection>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableSave" @click="saveUpdatedInfo" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import commonUtil from './commonutil.js';
import UserSelection from "./UserSelection.vue";
import constants from "./constants";

export default {
    components: {
        UserSelection,
    },

    props: {
        appData: Object,
        authUsers: Array,
    },

    data() {
        return {
            disableSave: true,
            selectedTitle: commonUtil.getMessageText(this.$i18n,"title_bell_auth"),
            selectionType: constants.USER_SELECTION_BELL_AUTH,
        };
    },

    created() {
    },

    methods: {
        handleChangeSelectedUser() {
            this.disableSave = false;
        },
        saveUpdatedInfo() {
            this.$emit('update' , this.$refs.UserSelection.removeTagList, this.$refs.UserSelection.addTagList);
        },
    }
}
</script>


<style scoped>
.input-with-select >>> .el-input-group__prepend {
    background-color: #fff;
}
.input-with-select >>> .el-select .el-input {
    font-size: 14px;
    width: 120px;
}
.input-with-select >>> .el-button {
    width: 40px;
    padding: 0;
}

</style>
